import { ActionTile } from "@fullscript/aviary-web";
import { useRef } from "react";

import * as styles from "../RegionSelectorPage.styles";

interface Props {
  region: string;
  label: string;
  content: string;
  icon: Parameters<typeof ActionTile>[0]["icon"];
}

const RegionTile = ({ region, label, content, icon }: Props) => {
  const formRef = useRef<HTMLFormElement>(null);

  const csrfToken =
    document.querySelector("meta[name='csrf-token']")?.getAttribute("content") ?? "";

  return (
    <form ref={formRef} method="post" action="/region-selector" css={styles.form}>
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      <input type="hidden" name="region" value={region} />
      <ActionTile
        label={label}
        content={content}
        icon={icon}
        showBorder
        intention="accentGreen"
        customCss={styles.tile}
        onClick={() => formRef.current?.submit()}
        type="button"
      />
    </form>
  );
};

export { RegionTile };
